module.exports = __webpack_public_path__ + "static/media/lp-timer.b2ba75af.png";